import React from 'react';

import { UserComponent } from 'react/UserComponent.jsx';

class OtherTeamNameComponent extends React.PureComponent {
	render() {
		const { match } = this.props;
		if(!match) {
			return null;
		}

		if(match.isSingles()) {
			return <UserComponent user={match.getOtherPlayers()[0]} />;
		}
		else if(match.isDoubles()) {
			return 'The Other Team';
		}
	}
}

export { OtherTeamNameComponent };